(function () {
  /* ---------- Tab switching ---------- */
  function initTabs(wrap) {
    var bar = wrap.querySelector('[data-pdi-tabs]');
    if (!bar) return;
    var btns = bar.querySelectorAll('[data-pdi-tab]');
    var pan = wrap.querySelectorAll('[data-pdi-panel]');
    function go(id) {
      btns.forEach(function (b) {
        var on = b.getAttribute('data-pdi-tab') === id;
        b.classList.toggle('is-active', on);
        b.setAttribute('aria-selected', on);
      });
      pan.forEach(function (p) {
        p.classList.toggle('is-active', p.getAttribute('data-pdi-panel') === id);
      });
    }
    btns.forEach(function (b) {
      b.addEventListener('click', function () { go(b.getAttribute('data-pdi-tab')); });
    });
  }

  /* ---------- Read-more expand / collapse ---------- */
  function isMobile() {
    return window.innerWidth <= 749;
  }

  function lineClampPx(el) {
    /* Measure from the first <p> inside so mobile font-size overrides are respected */
    var target = el.querySelector('p') || el;
    var style = window.getComputedStyle(target);
    var lhRaw = style.lineHeight;
    var lhPx = lhRaw === 'normal'
      ? parseFloat(style.fontSize) * 1.35
      : parseFloat(lhRaw);
    var lines = isMobile() ? 3 : 5;
    return lhPx * lines;
  }

  function applyClamp(el) {
    var maxH = lineClampPx(el);
    el.style.overflow = 'hidden';
    el.style.maxHeight = maxH + 'px';
  }

  function removeClamp(el) {
    el.style.overflow = 'visible';
    el.style.maxHeight = 'none';
  }

  function initReadMore(wrap) {
    var desc = wrap.querySelector('[data-pdi-expand]');
    var btn = wrap.querySelector('[data-pdi-read-more]');
    if (!desc || !btn) return;

    function setup() {
      /* Temporarily remove any clamp to measure full height */
      removeClamp(desc);
      var fullH = desc.scrollHeight;
      var clampH = lineClampPx(desc);

      if (fullH > clampH + 2) {          /* +2 px tolerance */
        applyClamp(desc);
        btn.style.setProperty('display', 'block', 'important');
        btn.setAttribute('aria-expanded', 'false');
        btn.textContent = 'Read More';
      } else {
        removeClamp(desc);
        btn.style.setProperty('display', 'none', 'important');
      }
    }

    btn.addEventListener('click', function () {
      var expanded = btn.getAttribute('aria-expanded') === 'true';
      if (expanded) {
        applyClamp(desc);
        btn.setAttribute('aria-expanded', 'false');
        btn.textContent = 'Read More';
      } else {
        removeClamp(desc);
        btn.setAttribute('aria-expanded', 'true');
        btn.textContent = 'Read Less';
      }
    });

    /* Run on load and on resize (viewport can switch mobile ↔ desktop) */
    setup();
    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(setup, 150);
    });
  }

  /* ---------- Bootstrap ---------- */
  function init(wrap) {
    initTabs(wrap);
    initReadMore(wrap);
  }

  document.querySelectorAll('[data-section-type="product-details-information"]').forEach(init);
  document.addEventListener('shopify:section:load', function (e) {
    var s = e.target && e.target.querySelector('[data-section-type="product-details-information"]');
    if (s) init(s);
  });
})();

